const numberToRem = (px: number, defaultValue: any = 0) => {
  const inRemString = +(px / 10).toFixed(2)
  return isNaN(inRemString) ? defaultValue : `${inRemString}rem`
}

export default numberToRem
